<div class="download">
    <div class="download__box">
        <h4 class="download__title">
            JOBSEEKERS - EXPERIENCE THE CONVENIENCE OF EMPLOYMENT WITH NEOJOBZ APP
        </h4>

        <p class="download__subtitle">
            Download NeoJobz App now and Register your profile, build your resume, find thousands of job vacancies, apply for the best jobs, and create your success story.
        </p>

        <a href="https://play.google.com/store/apps/details?id=com.app.neojobz"
           target="_blank"
           class="download__btn">
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play">
        </a>
        
        <a class="download__btn">
           <a class="download__btn app-store-disabled">
            <img src="assets/images/app-store.png" 
            alt="App Store">
        </a>
        </a>
    </div>
</div>